const formatHours = (decimalHours: number): string => {
  const hours = Math.floor(decimalHours);
  const minutes = Math.round((decimalHours - hours) * 60);
  return `${hours}:${minutes.toString().padStart(2, '0')}`;
};

export function formatTotalsToHoursMinutes(value: string | number): string {
  let valueStr = '';
  if (typeof value === 'string') {
    valueStr = value;
  } else {
    const numberTotal = Number(value);
    valueStr = formatHours(numberTotal);
  }

  const parts = valueStr.split(':').map(Number);
  let hours = 0;
  let minutes = 0;

  if (parts.length === 3) {
    hours = parts[0];
    minutes = parts[1];
  } else if (parts.length === 2) {
    hours = parts[0];
    minutes = parts[1];
  } else if (parts.length === 1) {
    hours = parts[0];
  }

  hours += Math.floor(minutes / 60);
  minutes %= 60;

  return `${hours.toString().padStart(2, '0')} hrs ${minutes.toString().padStart(2, '0')} min`;
}
